export default {
    verb: 'didCommit',
    namespace: 'deviceManagement',
    relation: 'readerMode',
    description: 'Refresh tenant Reader Modes after a committed change',
    // When a user makes GPS the default instead of Default, the server updates both
    // modes, but the save response contains only GPS. Refresh the list so Default
    // loses its checkmark too; otherwise the screen can show two defaults.
    // https://github.com/sstid/backbone/issues/2268
    logic: ({ dispatch }) => dispatch({}, { verb: 'refresh', namespace: 'deviceManagement', relation: 'readerMode' })
};
